"use client";

import { useCustomerStore } from "@portal/context/global/Customer/CustomerContext";
import { useUserStore } from "@portal/context/global/User/UserContext";
import * as Sentry from "@sentry/nextjs";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";

function PortalSentryScopeInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const uid = useUserStore((state) => state.uid);
  const email = useUserStore((state) => state.email);
  const displayName = useUserStore((state) => state.displayName);
  const tenantId = useUserStore((state) => state.tenantId);
  const isGreaterOps = useUserStore((state) => state.isGreaterOps);
  const isGreaterOpsViewEnabled = useUserStore(
    (state) => state.isGreaterOpsViewEnabled,
  );
  const activeHub = useCustomerStore((state) => state.activeHub);

  useEffect(() => {
    const searchParamKeys = searchParams
      ? Array.from(new Set(Array.from(searchParams.keys())))
      : [];

    Sentry.setUser({
      id: uid,
      email: email || undefined,
      username: displayName || undefined,
    });

    Sentry.setTag("tenant_id", tenantId);
    Sentry.setTag("active_hub_scope", activeHub?.scope);
    Sentry.setTag("is_greater_ops", isGreaterOps);
    Sentry.setTag("greater_ops_view_enabled", isGreaterOpsViewEnabled);

    Sentry.setContext("route", {
      pathname: pathname ?? "/",
      searchParamKeys,
    });

    Sentry.setContext("active_hub", {
      ids: activeHub?.id ?? [],
      name: activeHub?.name ?? null,
      scope: activeHub?.scope ?? null,
      externalId: activeHub?.externalId ?? null,
      xActiveHub: activeHub?.xActiveHub ?? null,
    });
  }, [
    activeHub,
    displayName,
    email,
    isGreaterOps,
    isGreaterOpsViewEnabled,
    pathname,
    searchParams,
    tenantId,
    uid,
  ]);

  return null;
}

export default function PortalSentryScope() {
  return (
    <Suspense fallback={null}>
      <PortalSentryScopeInner />
    </Suspense>
  );
}
